module.exports = __webpack_public_path__ + "static/media/portfolio-4.5a496f32.jpg";